import React, { Component } from "react";
import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";
import '../../css/BisharatMain.css';
import AuthService from "../../services/AuthService";
import { MemberLinkBtn } from "../../styles/Elements";
import Login from "../../pages/Login";
import translate from "../../languages/translate";


const required = value => {
  if (!value) {
    return (
      <div className="alertDanger" role="alert">
        <p className="alertDanger">
          {translate("mandatory")}
          </p> 
      </div>
    );
  }
};


const vpassword = value => {
  if (value.length < 6 || value.length > 40) {
    return (
      <div className="alertDanger" role="alert">
      <p className="alertDanger">
    {translate("password-not-appropriate")}
      </p>
      </div>
    );
  }
};


export default class ChangePassForm extends Component {
  constructor(props) {
    super(props);
    this.handleReset = this.handleReset.bind(this);
    this.onChangeoldPass = this.onChangeoldPass.bind(this);
    this.onChangenewPassword = this.onChangenewPassword.bind(this);
    this.onChangenewPasswordConfirmation = this.onChangenewPasswordConfirmation.bind(this);

    this.state = {
      username : "",  
      oldPass: "",
      newPassword: "",
      newPasswordConfirmation: "",
      successful: false,
      message: ""
    };
  }

  componentDidMount() {
    this.refreshChangePass();
  }


  refreshChangePass = ()  => {
    const { match: { params } } = this.props;
    const username = params.username;
    this.setState({
        username : username,
    })
    
  
    }

  onChangeoldPass(e) {
    this.setState({
        oldPass: e.target.value
    });
  }


  onChangenewPassword(e) {
    this.setState({
        newPassword: e.target.value
    });
  }

  onChangenewPasswordConfirmation(e) {
    this.setState({
        newPasswordConfirmation: e.target.value
    });
  }

  handleReset(e) {
    e.preventDefault();

    this.setState({
      message: "",
      successful: false
    });

    this.form.validateAll();

    if (this.checkBtn.context._errors.length === 0) {
      AuthService.changePassword(
        this.state.username,  
        this.state.oldPass,
        this.state.newPassword,
        this.state.newPasswordConfirmation
      ).then(
        response => {

          this.setState({
            message: response.data.message,
            successful: true
          }); 
         // window.location.href = `/profile`;
        },
        error => {
          const resMessage =
            (error.response &&
              error.response.data &&
              error.response.data.message) ||
            error.message ||
            error.toString();
          this.setState({
            successful: false,
            message: resMessage
          });
        }
      );
     
    }
  }

  render() {
    const loggedInUser = AuthService.getCurrentUser();
   
    
    return (

      <div className='mainCreate'>

{!loggedInUser ? 
        <Login></Login>
  : 
  <div className="top-container-forms modcreate-topform">
  <div className="create-form modcreate-form"> 
        <div className="register-not-signed">
          <Form
            onSubmit={this.handleReset}
            ref={c => {
              this.form = c;
            }}
          >
            {!this.state.successful && (
              <div>
                <div className="form-group">
                  <label htmlFor="oldPass">{translate("password")} </label>
                  <Input
                    type="password"
                    className="form-control-mod"
                    name="oldPass"
                    value={this.state.oldPass}
                    onChange={this.onChangeoldPass}
                    validations={[required, vpassword]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="newPassword">   {translate("newpassword")}  </label>
                  <Input
                    type="password"
                    className="form-control-mod"
                    name="newPassword"
                    value={this.state.newPassword}
                    onChange={this.onChangenewPassword}
                    validations={[required, vpassword]}
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="newPasswordConfirmation">    {translate("confirm-newpassword")}  </label>
                  <Input
                    type="password"
                    className="form-control-mod"
                    name="newPasswordConfirmation"
                    value={this.state.newPasswordConfirmation}
                    onChange={this.onChangenewPasswordConfirmation}
                    validations={[required, vpassword]}
                  />
                </div>

                <div className="form-group">
                  <button className="btn btn-primary btn-block">  {translate("changepassword")}</button>
                  {/* <MemberLinkBtnGold to={'/adminboard/'}> Back to Admin Board  </MemberLinkBtnGold>  */}
                </div>
                
              </div>
            )}

            {this.state.message && (
              <div className="form-group">
                <div
                  className={
                    this.state.successful
                      ? "alertSuccess" 
                      : "alertDanger"
                  }
                  role="alert"
                >
                  
                  {this.state.message === 'Request failed with status code 401' && translate("oldpass-notcorrect")} 
                  {this.state.message === 'Error: New Password not confirmed!' && translate("newpass-notsimilar")}
                  {this.state.message === 'Password changed succesfully.' && translate("success-change-pass")}
                  {this.state.message === 'Error: Token Invalid!' && "link-unavailable"}
                
                  

                </div>
             
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={c => {
                this.checkBtn = c;
              }}
            />
          </Form>
          <MemberLinkBtn to={'/profile'}> {translate("back")} </MemberLinkBtn>
      </div>
      </div>
</div>
  }

        </div>
    );
  }
} 